/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { getLoginRedirectLocation } from '../helpers/auth_redirect';
import { hasAnyRole } from '../helpers/authorization';

function AppRoute({
  component: Component,
  layout: Layout,
  isAuthProtected,
  allowedRoles,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthProtected && !localStorage.getItem('authUser')) {
          return (
            <Redirect
              to={getLoginRedirectLocation(props.location)}
            />
          );
        }

        if (allowedRoles) {
          const user = JSON.parse(localStorage.getItem('authUser'));

          if (!hasAnyRole(user, allowedRoles)) {
            return <Redirect to="/dashboard" />;
          }
        }

        return (
          <Layout>
            <Component {...props} />
          </Layout>
        );
      }}
    />
  );
}

AppRoute.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
};

export default AppRoute;
